export default __webpack_public_path__ + "static/media/nap2.7c66f578.png";